import { AxiosErrorHandler } from 'ui';
import { PublicEventSkeleton } from '../components';
import { useNodeEventByInvitationTokenQuery } from '../queries';
import { SharedEventContent } from './shared-event-content';

type P = {
  eventId: string;
  invitationToken: string;
};

const PublicSharedEvent = ({ eventId, invitationToken }: P) => {
  const {
    data: event,
    error: eventError,
    isFetching: isFetchingEvent,
  } = useNodeEventByInvitationTokenQuery({ eventId, invitationToken }, { throwOnError: false });

  return (
    <AxiosErrorHandler error={eventError}>
      {isFetchingEvent || !event ? (
        <PublicEventSkeleton />
      ) : (
        <SharedEventContent event={event} invitationToken={invitationToken} />
      )}
    </AxiosErrorHandler>
  );
};

export default PublicSharedEvent;
